const order = {
    getlist: 'order/admin-getlist',
    get: 'order/admin-get',
    changestatus: 'order/change-status',
    export: 'order/admin-export',
    ticket: 'ticket/admin-get',
}
export default order
